/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const GlyphSocialFbSimple = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 16 16",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M6.417 13.866L6.4 8.533H4.267V6.399H6.4V5.066c0-1.98 1.226-2.933 2.991-2.933.846 0 1.573.063 1.785.09v2.07H9.951c-.96 0-1.146.456-1.146 1.126v.98H11.6l-1.067 2.134H8.805v5.333H6.417z"
  }));
};
export default GlyphSocialFbSimple;